import { cn } from "@core-ui/utils/cn";
import type { GalleryView } from "@ext/markdown/elements/gallery/model/gallery";

// Cells are node views of other blocks, and their own styles outrank a utility class, hence `!` inside a cell.
const ITEMS = [
	"relative overflow-hidden rounded-[var(--gallery-radius)] [--gallery-radius:0.75em]",
	"[&>:is([data-gallery-cells],[data-node-view-content-react])]:contents",
	"[&>*>*]:relative [&>*>*]:m-0 [&>*>*]:overflow-hidden",
	"[&>*>*_:is(div,span):not(.absolute,.object-container)]:!m-0",
	"[&>*>*_:is(div,span):not(.absolute,.object-container)]:!h-full",
	"[&>*>*_:is(div,span):not(.absolute,.object-container)]:!w-full",
	"[&>*>*_:is(div,span):not(.absolute,.object-container)]:!max-w-none",
	"[&>*>*_:is(img,video,iframe)]:!h-full [&>*>*_:is(img,video,iframe)]:!w-full",
	"[&>*>*_:is(img,video,iframe)]:!max-w-none [&>*>*_:is(img,video,iframe)]:!rounded-none",
	"[&>*>*_:is(.resizer,.object-container,.resource-caption:not(.visible))]:!hidden",
	"[&>*>*_:is(em,.resource-caption)]:!absolute [&>*>*_:is(em,.resource-caption)]:!inset-x-0",
	"[&>*>*_:is(em,.resource-caption)]:!bottom-0 [&>*>*_:is(em,.resource-caption)]:!m-0",
	"[&>*>*_:is(em,.resource-caption)]:!max-h-none [&>*>*_:is(em,.resource-caption)]:!px-[0.75em]",
	"[&>*>*_:is(em,.resource-caption)]:!pb-[0.5em] [&>*>*_:is(em,.resource-caption)]:!pt-[2.5em]",
	"[&>*>*_:is(em,.resource-caption)]:!text-left [&>*>*_:is(em,.resource-caption)]:!text-[0.8em]",
	"[&>*>*_:is(em,.resource-caption)]:!leading-[1.3em] [&>*>*_:is(em,.resource-caption)]:!text-white",
	"[&>*>*_:is(em,.resource-caption)]:![background:linear-gradient(to_top,rgb(0_0_0/0.62),rgb(0_0_0/0.46)_25%,rgb(0_0_0/0.27)_50%,rgb(0_0_0/0.1)_75%,transparent)]",
	"[&>*>*_:is(em,.resource-caption)]:![text-shadow:0_1px_3px_rgb(0_0_0/0.5)]",
	"[&>*>*_.resource-caption::placeholder]:!text-white/70",
];

const VIEW_ITEMS: Record<GalleryView, string[]> = {
	mosaic: ["mx-auto", "[&>*>*]:absolute", "[&>*>*_:is(img,video)]:!object-cover"],
	carousel: [
		"flex gap-[0.5em] overflow-x-auto rounded-none [scrollbar-width:none]",
		"[&>*>*]:flex-none [&>*>*]:rounded-[var(--gallery-radius)]",
		"[&>*>*_:is(img,video)]:!object-contain",
	],
};

const getGalleryItemsClassName = (view: GalleryView) => cn(ITEMS, VIEW_ITEMS[view]);

export default getGalleryItemsClassName;
